import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, LogisticService } from '../../../services/logistic.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { RememberService } from '../../../core/services/remember.service';

@Component({
  selector: 'tt-trav-exp-types',
  templateUrl: './trav-exp-types.component.html',
  styleUrls: ['./trav-exp-types.component.css']
})
export class TravExpTypesComponent implements OnInit {
    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public itemsListTravelExpenseTypes: Item[] = [];

    public businessButtons: FormButton[] = [
        { id: 'erase', type: 'danger', icon: 'fa fa-solid fa-eraser', onClick: () => this.clear('businessco_no') }
    ];

    constructor(private stateService: StateService, private datatask: DataTaskService, private logistic: LogisticService, private rememberService: RememberService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(1268))[0];
    }

    private async loadCompanies(): Promise<void> {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async loadTravelExpenseTypes(): Promise<void> {
        if (!!this.setting?.businessco_no) {
            return this.itemsListTravelExpenseTypes = await this.datatask.Post(1267, {
                show_inactive: '1',
                businessco_no: this.setting?.businessco_no
            });
        }
    }

    private clear(id: string) {
        switch (id) {
            case 'businessco_no':
                if (!!this.setting) {
                    this.setting.businessco_no = '99999';

                    if (this.setting?.businessco_no === '99999') {
                        this.rememberService.remember('w_travexptypes.businessco_no', this.setting?.businessco_no);
                        this.loadTravelExpenseTypes();
                    }
                }
                break;
            default:
                break;
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        switch (id) {
            case 'businessco_no':
                this.loadTravelExpenseTypes();
                break;
            default:
                break;
        }
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'travexptype':
                this.stateService?.go('travexptype', { trextype_id: '+' });
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCompanies();
        this.loadTravelExpenseTypes();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    searchtext: string;
    businessco_no: string;
    show_setting: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('travExpTypes', {
//        templateUrl: 'views/components/views/travExpTypes/travExpTypes.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'travExpTypesService', 'logisticService', 'rememberService', 'layoutService', function (stateService, utilityService, travExpTypesService, logisticService, rememberService, layoutService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            let variableNames = {
//                businessco_no: '',
//                searchtext: ''
//            };

//            vm.model = {
//                tabletSize: layoutService.getMediaQueries().tablet,
//                businessButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('businessco_no') }
//                ],
//                searchTextButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('searchtext') }
//                ],
//                setting: {},
//                selectListCompanies: [],
//                itemsListTravExpTypes: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE CALLS

//            async function loadSetting() {
//                vm.model.setting = (await travExpTypesService.getTravelExpenseTypes())[0];

//                return loadTravelExpenseTypes();
//            }

//            async function loadCompanies() {
//                vm.model.selectListCompanies = await logisticService.listCompanies({ add_all: '1' });
//            }

//            async function loadTravelExpenseTypes() {
//                if (utilityService.validateParmsValue(vm.model.setting.businessco_no, true) !== true) return;

//                return vm.model.itemsListTravExpTypes = await travExpTypesService.listTravelExpenseTypes({
//                    show_inactive: '1',
//                    businessco_no: vm.model.setting.businessco_no
//                });
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'businessco_no':
//                    case 'searchtext':
//                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region RESET BUTTON FUNCTION

//            function clear(id) {
//                switch (id) {
//                    case 'businessco_no':
//                        vm.model.setting.businessco_no = '99999';

//                        if (vm.model.setting.businessco_no === '99999') {
//                            rememberFunc('businessco_no');
//                            loadTravelExpenseTypes();
//                        }
//                        break;
//                    case 'searchtext':
//                        vm.model.setting.searchtext = '';

//                        if (vm.model.setting.searchtext === '') rememberFunc('searchtext');
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion RESET BUTTON FUNCTION

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'travexptype':
//                        go({ trextype_id: '+' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON BLUR MULTI FUNCTIONS

//            vm.onBlur = function (id) {
//                switch (id) {
//                    case 'searchtext':
//                        if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;

//                        if (vm.model.setting.searchtext > '') rememberFunc('searchtext');
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion ON BLUR MULTI FUNCTIONS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'businessco_no':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.businessco_no) !== true) return;

//                        vm.model.setting.businessco_no = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.businessco_no, true) !== true) return;

//                        rememberFunc('businessco_no');
//                        loadTravelExpenseTypes();
//                        break;
//                    case 'searchtext':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.searchtext) !== true) return;

//                        vm.model.setting.searchtext = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;

//                        if (vm.model.setting.searchtext === '') rememberFunc('searchtext');
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadSetting();
//                loadCompanies();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
